export default "__VITE_ASSET__CPoDqT0N__"